export const GenericMaster = {
  projects: [
    {
      json_attribute: "proj_id",
      payload_attribute: "primedetails.projectid",
      alias: ["projectunitid"],
      db_column: "projectid",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "building_id",
      payload_attribute: "primedetails.buildingid",
    //   alias: ["projectunitid"],
      db_column: "buildingid",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "heading",
      payload_attribute: "primedetails.heading",
      alias: ["propstr"],
      db_column: "heading",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "subheading",
      payload_attribute: "primedetails.subheading",
    //   alias: ["propstr"],
      db_column: "subheading",
      type: "string",
      mandatory: false,
    },


    {
      json_attribute: "description",
      payload_attribute: "primedetails.description",
      alias: ["description.text"],
      db_column: "description",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "name",
      payload_attribute: "primedetails.projectname",
      alias: ["heading", "location.projectName"],
      db_column: "projectname",
      type: "string",
      mandatory: true,
    },
    {
      json_attribute: "locality_label",
      payload_attribute: "primedetails.locality_label",
      alias: ["location.localityName"],
      db_column: "locality_label",
      type: "string",
      mandatory: true,
    },
    {
      json_attribute: "city_label",
      payload_attribute: "primedetails.city_label",
      alias: ["location.cityName"],
      db_column: "city_label",
      type: "string",
      mandatory: true,
    },
        {
      json_attribute: "state_label",
      payload_attribute: "primedetails.state_label",
      alias: ["location.state_label"],
      db_column: "state_label",
      type: "string",
      mandatory: true,
    },

    {
      json_attribute: "latitude",
      payload_attribute: "primedetails.latitude",
      alias: ["location.latitude"],
      db_column: "latitude",
      type: "number",
      mandatory: false,
    },
    {
      json_attribute: "longitude",
      payload_attribute: "primedetails.longitude",
      alias: ["location.longitude"],
      db_column: "longitude",
      type: "number",
      mandatory: false,
    },

    {
      json_attribute: "displayprice",
      payload_attribute: "primedetails.displayprice",
      alias: ["price.label",["price_disp"]],
      db_column: "displayprice",
      type: "string",
      mandatory: false,
    },

    // {
    //   json_attribute: "price_disp",
    //   payload_attribute: "price_disp",
    //   alias: ["price.label"],
    //   db_column: "price_disp",
    //   type: "string",
    //   mandatory: false,
    // },

    {
      json_attribute: "proptypestr",
      payload_attribute: "primedetails.heading",
      alias: ["configSummary.cards[].configInfo.subLabel", "areaType"],
      db_column: "proptypestr",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "res_com",
      payload_attribute: "primedetails.res_com",
      alias: ["rescom"],
      db_column: "res_com",
      type: "string",
      mandatory: false,
    },


    // builder details
    {
      json_attribute: "buildername",
      payload_attribute: "builder.buildername",
      alias: ["builderName"],
      db_column: "buildername",
      type: "string",
      mandatory: true,
    },

    // possession
    {
      json_attribute: "possession_status",
      payload_attribute: "possession.status",
      alias: ["constructionStatusTag", "possessionStatus.label","datelabel"],
      db_column: "possession_status",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "posession_date",
      payload_attribute: "possession.possessiondate",
      alias: ["possessionStatus.label","possession_date_formatted"],
      db_column: "posession_date",
      type: "string",
      mandatory: false,
    },
    // {
    //   json_attribute: "possession_date_formatted",
    //   payload_attribute: "possession.possession_date_formatted",
    //   alias: ["possessionStatus.label"],
    //   db_column: "possession_date_formatted",
    //   type: "string",
    //   mandatory: false,
    // },
    // {
    //   json_attribute: "datelabel",
    //   payload_attribute: "possession.datelabel",
    //   alias: ["constructionStatusTag"],
    //   db_column: "datelabel",
    //   type: "string",
    //   mandatory: false,
    // },
    {
      json_attribute: "secondarydatelabel",
      payload_attribute: "possession.secondarydatelabel",
      alias: ["possessionStatus.label"],
      db_column: "secondarydatelabel",
      type: "string",
      mandatory: false,
    },


    // imagedetails
    {
      json_attribute: "image",
      payload_attribute: "imagedetails.main_image",
      alias: ["coverImage.url"],
      db_column: "image",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "image_alt_tag",
      payload_attribute: "imagedetails.main_image_alt_tag",
      alias: ["coverImage.altTag"],
      db_column: "image_alt_tag",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "logo",
      payload_attribute: "imagedetails.projectlogo",
      alias: [],
      db_column: "logo",
      type: "string",
      mandatory: false,
    },
    {
      json_attribute: "saleable_area_type",
      payload_attribute: "saleable_area_type",
      alias: ["areaType"],
      db_column: "saleable_area_type",
      type: "string",
      mandatory: false,
    },

    {
      json_attribute: "configuration",
      payload_attribute: "configuration",
      alias: ["configuaration","configSummary.cards[].configInfo.subLabel"],
      db_column: "configuration",
      type: "object",
      mandatory: false,
    },
    {
      json_attribute: "projectplan",
      payload_attribute: "projectplan",
      alias: ["configSummary.cards"],
      db_column: "projectplan",
      type: "array",
      mandatory: false,
    },
    {
      json_attribute: "project_summary_json",
      payload_attribute: "project_summary_json",
      alias: ["configSummary.cards"],
      db_column: "project_summary_json",
      type: "array",
      mandatory: false,
    },

    // {
    //   json_attribute: "rera_details",
    //   payload_attribute: "rera_details",
    //   alias: ["reraDisplayTag"],
    //   db_column: "rera_details",
    //   type: "object",
    //   mandatory: false,
    // },

    {
      json_attribute: "rera_details",
      payload_attribute: "rera_details",
      alias: ["reraDisplayTag"],
      db_column: "rera_details",
      type: "array",
      mandatory: false,
    },


    
    {
      json_attribute: "usp",
      payload_attribute: "usp",
      alias: ["keyHighlights.tuples"],
      db_column: "usp",
      type: "array",
      mandatory: false,
    },
    {
      json_attribute: "brochure",
      payload_attribute: "brochure",
      // alias: ["keyHighlights.tuples"],
      db_column: "brochure",
      type: "array",
      mandatory: false,
    },
{
  json_attribute: "carousalimages",
  payload_attribute: "otherimages",
  alias: ["projectCarousalImages[].images[]"],
  db_column: "otherimages",
  type: "array",
  mandatory: false
},
  {
      json_attribute: "property_videos",
      payload_attribute: "videos",
      // alias: ["keyHighlights.tuples"],
      db_column: "videos",
      type: "array",
      mandatory: false,
    },
  ],
};